import React from 'react'
import { styled } from '@mui/material/styles'
import { Box } from '@mui/material'
import { motion, AnimatePresence } from 'framer-motion'
import './Riichi.scss'

const RiichiBox = styled(Box)(
  ({ theme }) => `
  .content {
    color: ${theme.palette.background.default};
  }

  .win, &.team-win {
    background-color: ${theme.palette.score.riichiWin};
  }

  .lose, &.teal-lose {
    background-color: ${theme.palette.score.riichiLose};
  }
`
)

const Riichi = ({ riichi }) => {
  const anime = {
    initial: { opacity: 0 },
    animate: { opacity: 1 },
    exit: { opacity: 0 },
    transition: { duration: 0.4 }
  }

  const win = (
    <motion.div {...anime} key="win">
      <Box className="content win">
        リーチ
      </Box>
    </motion.div>
  )

  const lose = (
    <motion.div {...anime} key="lose">
      <Box className="content lose">
        リーチ
      </Box>
    </motion.div>
  )

  const teamWin = (
    <motion.div {...anime} key="team-win">
      <Box className="content team-win">
        チームリーチ
      </Box>
    </motion.div>
  )

  const teamLose = (
    <motion.div {...anime} key="team-lose">
      <Box className="content team-lose">
        チームリーチ
      </Box>
    </motion.div>
  )

  return (
    <RiichiBox className="riichi">
      <AnimatePresence>
        {riichi.win && win}
        {riichi.lose && lose}
        {riichi.teamWin && teamWin}
        {riichi.teamLose && teamLose}
      </AnimatePresence>
    </RiichiBox>
  )
}

export default Riichi
